import { render } from "./FlowTemplateForm.vue?vue&type=template&id=15f1f7cb"
import script from "./FlowTemplateForm.vue?vue&type=script&lang=js"
export * from "./FlowTemplateForm.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__